import styled from '@emotion/styled';
import { Col } from 'antd';
import React from 'react';

import { color, font, mediaQueries, shadow } from 'src/shared/styles/variables';

import * as S from '../../stepComponents/styles';

const BoxContainer = styled(Col)({
    paddingBottom: '1rem',
});

interface BoxProps {
    isHorizontal?: boolean;
}

const BoxWrapper = styled(Col)<BoxProps>(({ isHorizontal }) => ({
    backgroundColor: color.white,
    borderRadius: '0.5rem',
    margin: '0 1rem',
    display: 'flex',
    boxShadow: shadow.lightCardShadow,
    height: '100%',
    flexDirection: isHorizontal ? 'column' : 'row',
    [mediaQueries.sm]: {
        flexDirection: 'column',
    },
}));

const Heading = styled('h3')(
    {
        color: color.blueLagoon,
        margin: '2.5rem 0 1rem',
    },
    font.heavy(font.size.mediumExtended),
);

const ContentWrapper = styled(Col)({
    padding: '2rem',
});

const ImageWrapper = styled(Col)({
    position: 'relative',
    backgroundColor: color.polar,
    padding: '2rem',
    display: 'flex',
    alignItems: 'center',
});

interface StyledIconProps {
    iconUrl: string;
}

const StyledIcon = styled('i')<StyledIconProps>(({ iconUrl }) => ({
    display: 'block',
    backgroundImage: `url('${iconUrl}')`,
    maxWidth: '10rem',
    width: '100%',
    height: '7.5rem',
    margin: '0 auto',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPositionX: 'center',
}));

interface Props {
    isHorizontal: boolean;
    title: string;
    icon: string;
    list: string[];
}

export const CommonReactionsBox: React.SFC<Props> = ({ isHorizontal, title, icon, list }) => (
    <BoxContainer xs={24} md={12}>
        <BoxWrapper isHorizontal={isHorizontal}>
            <ImageWrapper sm={isHorizontal ? 24 : 8} md={isHorizontal ? 24 : 8}>
                <StyledIcon iconUrl={icon} />
            </ImageWrapper>
            <ContentWrapper sm={isHorizontal ? 24 : 16} md={isHorizontal ? 24 : 16}>
                <Heading>{title}</Heading>
                <S.BulletList>
                    {list.map(element => (
                        <S.BulletListElement isSmall key={element}>
                            {element}
                        </S.BulletListElement>
                    ))}
                </S.BulletList>
            </ContentWrapper>
        </BoxWrapper>
    </BoxContainer>
);
